import Swal from "sweetalert2";

export const showNotitfication = (
  text: string,
  type: "success" | "error",
  showClose?: boolean
): void => {
  Swal.fire({
    text: text,
    icon: type,
    showConfirmButton: false,
    timer: showClose ? undefined : 3000,
    showCloseButton: showClose,
    customClass: {
      popup: "ghaith--font-plexy",
    },
  });
};
